import { FILE_TYPE_EXTENSIONS } from "@common/constants/financial-documents";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { getImportStatus } from "@components/documents/lib";
import {
    ACCRUAL_DOCUMENT_FILE_TYPES,
    ACCRUAL_DOCUMENT_FILE_TYPES_NAMES,
} from "./accrualDocumentImporter.lib";

interface AccrualImporterDocumentEligibilityInput {
    financialDocument: FinancialDocumentListItem;
    importerQueue: string;
}

interface AccrualImporterDocumentEligibility {
    isSupportedFileType: boolean;
    isAlreadyAdded: boolean;
    isAlreadyImported: boolean;
    isDisabled: boolean;
    disabledTooltip?: string;
}

export function getAccrualImporterDocumentEligibility({
    financialDocument,
    importerQueue,
}: AccrualImporterDocumentEligibilityInput): AccrualImporterDocumentEligibility {
    const isSupportedFileType = ACCRUAL_DOCUMENT_FILE_TYPES.some((fileType) =>
        financialDocument.fileName
            .toLowerCase()
            .endsWith(FILE_TYPE_EXTENSIONS[fileType]),
    );
    const isAlreadyAdded = financialDocument.importerQueue === importerQueue;
    const isAlreadyImported = getImportStatus(financialDocument) === "done";

    let disabledTooltip: string | undefined;
    if (isAlreadyImported) {
        disabledTooltip = "Document has already been imported";
    } else if (isAlreadyAdded) {
        disabledTooltip = "Document is already in the importer";
    } else if (!isSupportedFileType) {
        disabledTooltip = `Only ${ACCRUAL_DOCUMENT_FILE_TYPES_NAMES} are supported`;
    }

    const isDisabled =
        !isSupportedFileType || isAlreadyAdded || isAlreadyImported;

    return {
        isSupportedFileType,
        isAlreadyAdded,
        isAlreadyImported,
        isDisabled,
        disabledTooltip,
    };
}
